import(/* webpackMode: "eager" */ "/home/runner/work/whoplays-web/whoplays-web/src/app/auth/signup/page.tsx");
